import type { OnboardingFormValues } from "@/app/onboarding/_lib/types";

export const ONBOARDING_DRAFT_VERSION = 5;
export const ONBOARDING_DRAFT_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 7;

export type OnboardingDraftValue = {
	values: OnboardingFormValues;
};

export function getOnboardingDraftStorageKey(userId: string) {
	return `clutch:onboarding-draft:${userId}`;
}
